import { Avatar, Card, ScrollArea } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import B2bTable from "components/reusable/b2bTable";
import { formatNumber } from "utiles/url";

const DriverCommissionTable = ({ ordersList }) => {
  const headerData = [
    {
      label: "Product Name",
      key: "product_name",
      sortable: false,
      searchable: true,
      render: (rowData) => <b>{rowData?.product_name}</b>,
    },
    {
      label: "Quantity",
      key: "quantity",
      sortable: false,
      searchable: true,
      render: (rowData) => <span>{rowData?.quantity}</span>,
    },
    {
      label: "Price",
      key: "price",
      sortable: false,
      searchable: false,
      render: (rowData) => <span>{formatNumber(rowData.price)}</span>,
    },
    {
      label: "Image",
      key: "avatar",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return (
          <Avatar.Group spacing="sm">
            <Avatar src={rowData.image} radius="xl" />
          </Avatar.Group>
        );
      },
    },
  ];
  const { height } = useViewportSize();

  return (
    <div style={{ width: "100%", margin: "auto" }}>
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <Card shadow="sm" p="lg">
          <ScrollArea>
            <B2bTable
              header={headerData}
              data={ordersList || []}
              layout={{ minWidth: 700 }}
              total={1}
              searchInput={false}
              activePage={1}
              loading={false}
            />
          </ScrollArea>
        </Card>
      </ScrollArea>
    </div>
  );
};

export default DriverCommissionTable;
